import { useState } from "react";
import { Form, Button, Card, Image, InputGroup } from "react-bootstrap";
import Cookies from "js-cookie";
import styles from "./AdminLogin.module.css";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import ToastMessage from "../../components/messagetoast/ToastMessage";
import { Colorlogo } from "../../controller/Images";
import { AxiosInstance } from "../../axios";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "success",
  });

  const navigate = useNavigate();

  const showToast = (message, variant = "success") => {
    setToast({ show: true, message, variant });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await AxiosInstance.post(
        "/api/login",
        {
          email,
          password,
        }
      );

      const data = response.data;

      if (data.status && data.user) {

        const cookieOptions = rememberMe
          ? { expires: 7, path: "/" }
          : { path: "/" };
        const user = data.user;

        // ✅ Store each field as an individual cookie
        // Cookies.set("user_id", user.id, cookieOptions);
        Cookies.set("full_name", user.full_name, cookieOptions);
        Cookies.set("user_type", user.user_type, cookieOptions);
        Cookies.set("user_designation", user.user_desination, cookieOptions);
        Cookies.set("user_id", user.user_id, cookieOptions); // user_id from backend (UUID)
        Cookies.set("user_name", user.user_name, cookieOptions);
        Cookies.set("email", user.email, cookieOptions);
        Cookies.set("access_token", user.access_token, cookieOptions);
        Cookies.set("refresh_token", user.refresh_token, cookieOptions);

        // ✅ Also store the full user object as JSON
        Cookies.set("user_info", JSON.stringify(user), cookieOptions);

        showToast("Login successful!", "success");

        setTimeout(() => {
          navigate("/admin/lets-talk");
        }, 1000);
      } else {
        console.error("Login failed:", data.message || "Unknown error");
        showToast(data.message || "Invalid credentials", "danger");
      }
    } catch (error) {
      console.error("Error during login:", error);
      showToast("An error occurred during login. Please try again.", "danger");
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <div className={styles.loginPageContainer}>
      <div className={styles.wave}></div>
      <Card className={styles.loginCard}>
        <div className={styles.logoContainer}>
          <Image
            src={Colorlogo}
            alt="Bharat Clouds Logo"
            className={styles.logo}
            fluid
          />
          {/* <p className="text-muted mt-2">Infinite solutions</p> */}
        </div>

        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formBasicEmail" className={styles.formGroup}>
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email address"
              className={styles.formControl}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group
            controlId="formBasicPassword"
            className={styles.formGroup}
          >
            <Form.Label>Password</Form.Label>
            <InputGroup>
              <Form.Control
                type={passwordShown ? "text" : "password"}
                placeholder="Enter password"
                className={styles.formControl}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <InputGroup.Text
                className={styles.passwordEyeIcon}
                onClick={togglePasswordVisibility}
              >
                {passwordShown ? <EyeSlashFill /> : <EyeFill />}
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>

          <Form.Group
            controlId="formBasicCheckbox"
            className={styles.rememberMe}
          >
            <Form.Check
              type="checkbox"
              label="Remember me"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className={`my-3 ${styles.formCheckInput}`}
            />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className={`my-2 ${styles.loginButton}`}
          >
            Log In
          </Button>
        </Form>
      </Card>

      <ToastMessage
        show={toast.show}
        onClose={() => setToast({ ...toast, show: false })}
        message={toast.message}
        variant={toast.variant}
      />
    </div>
  );
};

export default AdminLogin;
